import {
  UseTranslationOptions as I18NextUseTranslationOptions,
  UseTranslationResponse,
  useTranslation,
} from "react-i18next";
import { useEffect, useState } from "react";
import { localeNameSpaces } from "./constants";

// useTranslation use for react projects
export { UseTranslationResponse, useTranslation };

/**
 * @deprecated This function is deprecated. Please use `useTranslation` instead.
 * Initializes i18next and returns the i18next instance along with a translation function for the specified namespace.
 */
export const useIsolatedTranslation = (namespace: localeNameSpaces) => useTranslation(localeNameSpaces[namespace]);

const runsOnServerSide = typeof window === "undefined";
export type UseTranslationOptions<K extends string> = I18NextUseTranslationOptions<K>;

// useTranslationNextJs use for nextJs project
export function useTranslationNextJs<K extends string>(
  lng: string,
  ns: string,
  options?: I18NextUseTranslationOptions<K>
) {
  const ret = useTranslation(ns, options);
  const { i18n } = ret;
  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    // eslint-disable-next-line no-void
    void i18n.changeLanguage(lng);
  } else {
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);
    useEffect(() => {
      if (activeLng === i18n.resolvedLanguage) return;
      setActiveLng(i18n.resolvedLanguage);
    }, [activeLng, i18n.resolvedLanguage]);
    useEffect(() => {
      if (!lng || i18n.resolvedLanguage === lng) return;
      // eslint-disable-next-line no-void
      void i18n.changeLanguage(lng);
    }, [lng, i18n]);
  }
  return ret;
}
